import { render, staticRenderFns } from "./AlertTip.vue?vue&type=template&id=9bb81b16&scoped=true&"
import script from "./AlertTip.vue?vue&type=script&lang=js&"
export * from "./AlertTip.vue?vue&type=script&lang=js&"
import style0 from "./AlertTip.vue?vue&type=style&index=0&id=9bb81b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb81b16",
  null
  
)

export default component.exports